import styled from "styled-components";

export const OverflowWrapper = styled.section`
    overflow-wrap: anywhere;
    word-break: break-all;
`;